"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClient = void 0;
const axios_1 = require("axios");
const qs = require("./Qs");
const DebugConfig = require("./config/Debug");
const E = require("./Errors");
const Log = require("./logger");
class HttpClient {
    _client;
    _sessionInstance;
    constructor(options) {
        this._client = axios_1.default.create({
            baseURL: options.baseUrl,
            timeout: options.timeout ?? 30000,
            withCredentials: true
        });
        this._sessionInstance = options.sessionInstance;
        this._client.interceptors.request.use(async (conf) => {
            if (conf.sendToken && this._sessionInstance) {
                const session = this._sessionInstance;
                if (!session.isAccountCenterLogin) {
                    await session.goLogin();
                }
                const token = await session.getToken();
                const tokenCreateTime = session.getTokenCreateTime();
                conf.tokenCreateTime = tokenCreateTime;
                conf.headers.authorization = token;
            }
            const ret = await options.configRequest?.onFulfilled?.(conf) ?? conf;
            if (DebugConfig.RequestFeature.hasContext()) {
                conf.requestId = Date.now();
                DebugConfig.tryToLog(() => Log.requestPattern.format(new Log.RequestBuilder(ret, 'info'), Log.requestLogFormat));
            }
            return ret;
        }, function (err) {
            return options.configRequest?.onRejected?.(err) ?? err;
        });
        this._client.interceptors.response.use((res) => {
            if (DebugConfig.ResponseFeature.hasContext()) {
                DebugConfig.tryToLog(() => Log.responsePattern.format(new Log.ResponseBuilder(res, 'info'), Log.responseLogFormat));
            }
            const ret = res.data;
            return options.receivingResponse?.onFulfilled?.(ret, res) ?? ret;
        }, async (err) => {
            const code = err?.response?.data?.error?.code;
            const session = this._sessionInstance;
            const isAxiosError = err?.isAxiosError;
            if (DebugConfig.ResponseErrorFeature.hasContext() && isAxiosError) {
                DebugConfig.tryToLog(() => Log.errorPattern.format(new Log.ErrorBuilder(err, 'error'), Log.errorLogFormat));
            }
            /**
             * 8198: token expire
             * 12308: error when get token (Auth header invalid)
             * 8213: forced_logout
             */
            if (session) {
                if (code === 12308) {
                    await session.goLogin();
                }
                if (code === 8198 || code === 8213) {
                    const currentTokenCreateTime = err.response.config?.tokenCreateTime;
                    const latestTokenCreateTime = session.getTokenCreateTime();
                    if (currentTokenCreateTime === latestTokenCreateTime) {
                        await session.refreshToken();
                    }
                }
            }
            let error = err;
            if (err?.code === 'ECONNABORTED') {
                error = new E.E_TIME_OUT();
            }
            throw (await options.receivingResponse?.onRejected?.(err) ?? error);
        });
    }
    get(url, queryString, option) {
        const delimiter = url.includes('?') ? '&' : '?';
        const end = queryString ? `${delimiter}${qs.stringify(queryString)}` : '';
        // option = addCarryTokenParam(option, carryToken);
        return this._client.get(`${url}${end}`, option);
    }
    post(url, body, option) {
        return this._client.post(url, body, option);
    }
    put(url, body, option) {
        return this._client.put(url, body, option);
    }
    delete(url, queryString, option) {
        const delimiter = url.includes('?') ? '&' : '?';
        return this._client.delete(`${url}${delimiter}${qs.stringify(queryString)}`, option);
    }
    patch(url, body, option) {
        return this._client.patch(url, body, option);
    }
}
exports.HttpClient = HttpClient;
//# sourceMappingURL=Base.js.map